import Home from "./pages/Home";
import SystemRequirements from "./pages/SystemRequirements";
import Requirements from "./pages/Requirements";
import RamsActivity from "./pages/RamsActivity";
import SWComponents from "./pages/SWComponents";
import TestCases from "./pages/TestCases";
import TestResults from "./pages/TestResults";
import Devices from "./pages/Devices";
import EraFeatures from "./pages/EraFeatures";
import EraRequirements from "./pages/EraRequirements";
import EraRequirementsExt from "./pages/EraRequirementsExt";
import EraRequirementsV4 from "./pages/EraRequirementsV4";
import EraTestCases from "./pages/EraTestCases";
import SWVersions from "./pages/SWVersions";
import Docs from "./pages/Docs";
import Abbreviations from "./pages/Abbreviations";
import DmiTerms from "./pages/DmiTerms";
import EtcsVariablePrefixes from "./pages/EtcsVariablePrefixes";
import EN50126Docs from "./pages/EN50126Docs";
import EN50716Docs from "./pages/EN50716Docs";
import Users from "./pages/Users";

export const appRoutes = [
  { path: "/home", component: Home, passUser: true },
  { path: "/system-requirements", component: SystemRequirements, passUser: true },
  { path: "/requirements", component: Requirements, passUser: true },
  { path: "/sw-components", component: SWComponents, passUser: true },
  { path: "/test-cases", component: TestCases, passUser: true },
  { path: "/test-results", component: TestResults, passUser: true },
  { path: "/devices", component: Devices, passUser: true },
  { path: "/sw-versions", component: SWVersions, passUser: true },
  { path: "/rams-activities", component: RamsActivity },
  { path: "/en50126-docs", component: EN50126Docs, passUser: true },
  { path: "/en50716-docs", component: EN50716Docs, passUser: true },
  { path: "/dmi-terms", component: DmiTerms },
  { path: "/abbreviations", component: Abbreviations },
  { path: "/etcs-variable-prefixes", component: EtcsVariablePrefixes },
  { path: "/docs", component: Docs, passUser: true },
  { path: "/users", component: Users, passUser: true, roles: ["PM"] },
  { path: "/era-features", component: EraFeatures },
  { path: "/era-requirements", component: EraRequirements, passUser: true, props: { title: "ERA Requirements_v3", apiBase: "/api/era-requirements" } },
  { path: "/era-requirements-ext", component: EraRequirementsExt, passUser: true, props: { title: "ERA Requirements_v3+", apiBase: "/api/era-requirements-ext" } },
  { path: "/era-requirements-v4", component: EraRequirementsV4, passUser: true, props: { title: "ERA Requirements_v4", apiBase: "/api/era-requirements-v4" } },
  { path: "/era-test-cases", component: EraTestCases }
];

export const navigationItems = [
  { label: "Home", path: "/home" },
  {
    label: "Links",
    children: [
      {
        label: "ERA",
        href: "https://www.era.europa.eu/era-folder/ertms"
      },
      {
        label: "ERTMS",
        href: "https://www.ertms.net/"
      },
      {
        label: "openETCS",
        href: "http://openetcs.org/"
      },
      {
        label: "Redmine",
        href: "https://redmine.vavsvnsrvapp.azd.local/"
      },
      {
        label: "SVN",
        href: "https://svn.vavsvnsrvapp.azd.local/BEA/"
      }
    ]
  },
  {
    label: "References",
    children: [
      { label: "Terms", path: "/dmi-terms" },
      { label: "Abbreviations", path: "/abbreviations" },
      { label: "ETCS variables prefixes", path: "/etcs-variable-prefixes" },
      { label: "Docs", path: "/docs" }
    ]
  },
  {
    label: "ERA",
    children: [
      { label: "Requirements_v3", path: "/era-requirements" },
      { label: "Requirements_v3+", path: "/era-requirements-ext" },
      { label: "Requirements_v4", path: "/era-requirements-v4" },
      { label: "Features", path: "/era-features" },
      { label: "Test Cases", path: "/era-test-cases" },
      { label: "Test Sequences", href: "http://dmi.bsast.com:8080/" },
      { label: "MDBs Viewer", href: "https://dmi.bsast.com:8081/login?next=/" }
    ]
  },
  { label: "Devices", path: "/devices" },
  { label: ["System", "Requirements"], path: "/system-requirements" },
  { label: "RAMS Activities", path: "/rams-activities" },
  {
    label: ["Software", "Development"],
    children: [
      { label: "Requirements", path: "/requirements" },
      { label: "Test Specifications", path: "/test-cases" },
      { label: "Components", path: "/sw-components" },
      { label: "Test Reports", path: "/test-results" },
      { label: "Versions", path: "/sw-versions" }
    ]
  },
  { label: "EN50126", path: "/en50126-docs" },
  { label: "EN50716", path: "/en50716-docs" },
  { label: "Users", path: "/users", roles: ["PM"] }
];




